// Pure helpers for the WorkspaceSwitcher popover (filter substring
// match + arrow-key highlight clamping). Tested in isolation via
// vitest+jsdom; consumed by `app.jsx` through `window.mindexWS`
// (attached by vendor.entry.js so the globals exist before app.js runs).

export function filterWorkspaces(workspaces, query) {
  if (!query) return workspaces;
  const q = query.toLowerCase();
  return workspaces.filter((w) =>
    w.handle.toLowerCase().includes(q) ||
    (w.display_name || '').toLowerCase().includes(q)
  );
}

export function clampHighlight(next, length) {
  if (length <= 0) return 0;
  return Math.min(Math.max(next, 0), length - 1);
}
